<section id="skills" class="section" appReveal>
  <p class="eyebrow mb-2">What I work with</p>
  <div class="mb-8 flex flex-wrap items-end justify-between gap-4">
    <h2 class="section-title">Skills</h2>
    <input
      type="text"
      [(ngModel)]="filteredCategory"
      placeholder="Filter skills…"
      class="input max-w-xs"
    />
  </div>

  <div class="grid gap-4 sm:grid-cols-2">
    <div *ngFor="let skill of skills | filter:filteredCategory:''" class="card">
      <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-cyan-600 dark:text-cyan-400">
        {{ skill.category }}
      </h3>
      <div class="flex flex-wrap gap-2">
        <span class="chip" *ngFor="let item of skill.skillSet">{{ item }}</span>
      </div>
    </div>
  </div>
</section>
